import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function RecoveryThresholdReconstructStep() {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "reconstruct-heading", "aria-busy": "true", children: [_jsx("h3", { id: "reconstruct-heading", children: t('recovery.threshold_reconstruct.heading') }), _jsx("p", { role: "status", children: t('recovery.threshold_reconstruct.status') })] }));
}
//# sourceMappingURL=threshold-reconstruct-step.js.map